/* import __COLOCATED_TEMPLATE__ from './auto-pause-on-away-section.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-management */

import Component from '@glimmer/component';
import { action } from '@ember/object';

interface Args {
  autoPauseEnabled: boolean;
  updateTrackedProperty: (key: string, value: boolean) => void;
  persistAutoPauseOnAwaySetting?: () => void;
  isAutoAwayDisabled?: boolean;
}

interface Signature {
  Args: Args;
  Element: never;
}

export default class AutoPauseOnAwaySection extends Component<Signature> {
  @action
  toggleAutoPause() {
    this.args.updateTrackedProperty('autoPauseEnabled', !this.args.autoPauseEnabled);
    if (this.args.persistAutoPauseOnAwaySetting) {
      this.args.persistAutoPauseOnAwaySetting();
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Helpdesk::TabsComponents::AutoPauseOnAwaySection': typeof AutoPauseOnAwaySection;
  }
}
